export interface AppConfig {
  cognitoDomain: string;
  userPoolClientId: string;
  region: string;
  /** API Gateway origin, no trailing slash. */
  apiUrl: string;
}

export function parseConfig(raw: unknown): AppConfig {
  const o = (raw ?? {}) as Record<string, unknown>;
  const str = (k: string): string => {
    const v = o[k];
    if (typeof v !== 'string' || v.trim() === '') throw new Error(`config.json: "${k}" is missing`);
    return v.trim();
  };
  return {
    cognitoDomain: str('cognitoDomain'),
    userPoolClientId: str('userPoolClientId'),
    region: typeof o.region === 'string' ? o.region : '',
    apiUrl: str('apiUrl').replace(/\/+$/, ''),
  };
}

/** Runtime configuration deployed next to the SPA (the CDK stack writes the real file). */
export async function loadConfig(): Promise<AppConfig> {
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) throw new Error(`Could not load /config.json (${res.status})`);
  return parseConfig(await res.json());
}
